import type { ISbStoryData } from '@storyblok/js'
import { useStoryblokState } from '@storyblok/react'
import type { Page } from '@percent/cause-dashboard/storyblok/types/storyblok-components'
import { STORYBLOK_RESOLVE_RELATIONS } from '@percent/cause-dashboard/storyblok/home/useHomePageStory'
import { extractFirstSpotlightBannerFromPageStory } from '@percent/cause-dashboard/storyblok/home/extractFirstSpotlightBannerFromPageStory'
import { resolveSpotlightBannerCta } from '@percent/cause-dashboard/storyblok/home/resolveSpotlightBannerCta'
import { SpotlightBanner } from '@percent/cause-dashboard/common/components/storyblok/spotlightBanner/SpotlightBanner'

export type HomePageSpotlightBannerBridgeProps = {
  initialStory: ISbStoryData<Page>
  onCtaClick: (programmeOfferName: string) => void
}

export function HomePageSpotlightBannerBridge({
  initialStory,
  onCtaClick
}: Readonly<HomePageSpotlightBannerBridgeProps>) {
  const bridged = useStoryblokState(initialStory, {
    resolveRelations: STORYBLOK_RESOLVE_RELATIONS
  })
  const story = bridged ?? initialStory

  const banner = extractFirstSpotlightBannerFromPageStory(story)

  if (!banner) {
    return null
  }

  const cta = resolveSpotlightBannerCta(banner)

  return (
    <SpotlightBanner
      preTitle={banner.pre_title}
      title={banner.title}
      description={banner.description}
      ctaLabel={banner.cta_label}
      cta={cta ?? undefined}
      backgroundImage={{
        src: banner.background_image?.filename ?? '',
        alt: banner.background_image?.alt ?? ''
      }}
      onCtaClick={() => onCtaClick(banner.title)}
    />
  )
}
